import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Button
} from 'semantic-ui-react'

const CardEmployeeInfoManagementUX = (props: any) => {
    return(
      <div
        id="ModEditDiscountUX-div-0"
        style={{padding: "10px"}}>
        <Form
          id="CardEmployeeInfoManagementUX-Form-1">
          <FormGroup
            id="CardEmployeeInfoManagementUX-FormGroup-2"
            inline={true}>
            <FormField
              id="CardEmployeeInfoManagementUX-FormField-3"
              inline={true}
              style={{display: props.filteredTabMenu?.includes("EMPLOYEE_LIST")?"":"none"}}>
              <Button
                color={props.tab==="EMPLOYEE_LIST"?"blue":undefined}
                id="CardEmployeeInfoManagementUX-Button-6"
                name="EMPLOYEE_LIST"
                onClick={props.onChangeTab}
                size="small">
                Employee Lists
              </Button>
            </FormField>
            <FormField
              id="CardEmployeeInfoManagementUX-FormField-4"
              inline={true}
              style={{display: props.filteredTabMenu?.includes("EMPLOYEE_SWH")?"":"none"}}>
              <Button
                color={props.tab==="EMPLOYEE_SWH"?"blue":undefined}
                id="CardEmployeeInfoManagementUX-Button-7"
                name="EMPLOYEE_SWH"
                onClick={props.onChangeTab}
                size="small">
                Employee Summary work hour
              </Button>
            </FormField>
            <FormField
              id="CardEmployeeInfoManagementUX-FormField-5"
              inline={true}
              style={{display: props.filteredTabMenu?.includes("EMPLOYEE_TA")?"":"none"}}>
              <Button
                color={props.tab==="EMPLOYEE_TA"?"blue":undefined}
                id="CardEmployeeInfoManagementUX-Button-8"
                name="EMPLOYEE_TA"
                onClick={props.onChangeTab}
                size="small">
                Employee Time Attendance
              </Button>
            </FormField>
          </FormGroup>
        </Form>
        <div
          className="ui divider"
          id="CardEmployeeInfoManagementUX-div-9"
          style={{margin: "-0.5rem 0 0.75rem"}}>

        </div>
      </div>
    )
}


export default CardEmployeeInfoManagementUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Mon Jul 07 2025 09:30:23 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-Form-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-FormGroup-2"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-FormField-3"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"EMPLOYEE_LIST\")?\"\":\"none\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-FormField-4"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"EMPLOYEE_SWH\")?\"\":\"none\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-FormField-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"EMPLOYEE_TA\")?\"\":\"none\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "Button",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": "Employee Lists"
        },
        "color": {
          "type": "code",
          "value": "props.tab===\"EMPLOYEE_LIST\"?\"blue\":undefined"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-Button-6"
        },
        "name": {
          "type": "value",
          "value": "EMPLOYEE_LIST"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "Button",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "Employee Summary work hour"
        },
        "color": {
          "type": "code",
          "value": "props.tab===\"EMPLOYEE_SWH\"?\"blue\":undefined"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-Button-7"
        },
        "name": {
          "type": "value",
          "value": "EMPLOYEE_SWH"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "Button",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "Employee Time Attendance"
        },
        "color": {
          "type": "code",
          "value": "props.tab===\"EMPLOYEE_TA\"?\"blue\":undefined"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-Button-8"
        },
        "name": {
          "type": "value",
          "value": "EMPLOYEE_TA"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"-0.5rem 0 0.75rem\"}"
        }
      },
      "seq": 9,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardEmployeeInfoManagementUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 75
}

*********************************************************************************** */
